/**
 * TT-08 — Shopper Approved rating merge
 *
 * Shopper Approved's widget injects its own Product JSON-LD into <head> after
 * its script loads. That block carries the only live rating data available to
 * the storefront (SA exposes nothing to Liquid), but it is not usable as-is:
 *
 *   - "url" points at the myshopify.com admin domain, not the storefront
 *   - "@id" is a relative path ("products/body-butter"), which is invalid
 *   - it has no offers / brand / sku / description, so Google rejects it as a
 *     Product rich result and the stars never appear
 *
 * Two Product nodes describing the same page would also compete with each
 * other. So: lift aggregateRating and review[] off SA's node onto the theme's
 * server-rendered Product node, then remove SA's.
 *
 * If SA never loads, the theme node stands on its own — valid Product schema,
 * just without stars. Nothing breaks.
 */
(function () {
  'use strict';

  var TARGET_ID = 'tt-product-schema';
  var TIMEOUT_MS = 15000;
  var POLL_MS = 250;

  var target = document.getElementById(TARGET_ID);
  if (!target) return;

  function isShopperApprovedNode(node) {
    if (node === target) return false;
    if (node.type !== 'application/ld+json') return false;
    try {
      var data = JSON.parse(node.textContent);
      return data && data['@type'] === 'Product' && !!data.aggregateRating;
    } catch (e) {
      return false;
    }
  }

  function merge() {
    var nodes = document.querySelectorAll('script[type="application/ld+json"]');
    var source = null;
    var sourceData = null;

    for (var i = 0; i < nodes.length; i++) {
      if (isShopperApprovedNode(nodes[i])) {
        source = nodes[i];
        try {
          sourceData = JSON.parse(source.textContent);
        } catch (e) {
          return false;
        }
        break;
      }
    }

    if (!source || !sourceData) return false;

    var product;
    try {
      product = JSON.parse(target.textContent);
    } catch (e) {
      return true; // theme node is malformed; stop retrying either way
    }

    var rating = sourceData.aggregateRating;
    var ratingValue = rating && parseFloat(rating.ratingValue);
    var reviewCount = rating && parseInt(rating.reviewCount, 10);

    // Google rejects aggregateRating with a zero or missing count.
    if (ratingValue > 0 && reviewCount > 0) {
      product.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: ratingValue,
        reviewCount: reviewCount,
        bestRating: 5,
        worstRating: 1
      };

      if (Array.isArray(sourceData.review) && sourceData.review.length) {
        product.review = sourceData.review.slice(0, 20);
      }

      target.textContent = JSON.stringify(product);
    }

    // Drop SA's node whether or not the rating was usable — it is invalid
    // either way and only competes with the theme's Product node.
    if (source.parentNode) source.parentNode.removeChild(source);

    return true;
  }

  if (merge()) return;

  var startedAt = Date.now();
  var timer = window.setInterval(function () {
    if (merge() || Date.now() - startedAt > TIMEOUT_MS) {
      window.clearInterval(timer);
    }
  }, POLL_MS);
})();
